import React, { useEffect, useState } from "react";

import useTranslation from "next-translate/useTranslation";

import { ComponentErrorBoundary } from "shared/components/atoms/ComponentErrorBoundary";
import Carousel from "shared/components/organisms/Carousel";
import api from "shared/infra/services/api";

import { Container } from "./styles";

function OthersCourses({ course, courses }) {
  const { t } = useTranslation();

  function sortRandom(array) {
    const filteredArray = array?.filter(
      (element) => course?.id !== element.id && element.status === "published",
    );

    return filteredArray?.sort(() => 0.5 - Math.random());
  }

  const responsivenessSettings = {
    768: { items: 1 },
    1024: { items: 2 },
    1366: { items: 3 },
  };

  return (
    <>
      {sortRandom(courses)?.length > 0 && (
        <Container className="course-custom-card">
          <h1>{t("common:othersCourses")}</h1>

          <div className="other-courses-body">
            <div className="carousel-container">
              <ComponentErrorBoundary>
                <Carousel
                  zIndex={null}
                  context="course"
                  items={sortRandom(courses)}
                  customResponsivenessSettings={responsivenessSettings}
                />
              </ComponentErrorBoundary>
            </div>
          </div>
        </Container>
      )}
    </>
  );
}

export default OthersCourses;
